import { render, staticRenderFns } from "./FieldsetContractInvoicing.yaml?vue&type=template&id=23f8bd1f&component"
import script from "./FieldsetContractInvoicing.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetContractInvoicing.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports